<template>
    <div v-if="!this.banners == false || this.banners.length > 0" class="ba6-banner-top">
        <div class="ba6-carousel">
            <a
                v-for="b,i in banners" :key="i"
                :href="b.action"
                :target="b.target"
                :class="[ _isEmpty(b.action) ? 'disable-click' : '']"
                @click="!_isEmpty(b.action) && b.action[0] == '#' ? openModal(b) : ''"
            >
                <img
                    :class="['ba6-carousel-image', imageIndex == i ? 'ba6-carousel-image-is-active' : '']"
                    :src="b.url"
                >
            </a>
        </div>
        <div class="ba6-carousel-control">
            <button
                v-for="b,i in banners.length" :key="i"
                :class="['ba6-control-button', imageIndex == i ? 'ba6-control-button-is-active' : '']"
                @click="imageIndex = i, setTimer()"
            ></button>
        </div>
        <div class="modal fade" id="modalVideo" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content modal_favorite_tools">
                    <div class="modal-body">
                        <iframe class="get-started-modal__card__iframe"
                            width="560" height="315" :src="iframeSrc" title="YouTube video player"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen/>
                    </div>
                </div>
            </div>
        </div>
        <twenty-four-retrospective :data="banners" :user="user" :t="t" :retrospective="retrospective" />
    </div>
</template>

<script>
    export default {
        name: "ba6-banner-top",
        props: ['banners','user','t','retrospective'],
        data() {
            return {
                imageIndex: 0,
                currentElement: '',
                timer: null,
                iframeSrc: null,
                firstRetrospectiveAccess: true
            }
        },
        mounted(){
            if(!this.banners == false || this.banners.length > 0){
                this.setTimer()
            }
            $("#modalVideo").on('hidden.bs.modal', (e) => {
                this.iframeSrc = null
            });
        },
        methods: {
            setTimer(){
                clearInterval(this.timer)
                this.timer = setInterval(this.showBannerCarousel, 5000)
            },
            showBannerCarousel(){
                this.currentElement = this.banners[this.imageIndex]
                this.imageIndex = (this.imageIndex + 1) % this.banners.length
            },
            openModal(data){
                if(data.action_type == "modal") {
                    if(data.action == '#retrospective-2024'){
                        this.defineRetrospective2024()
                    } else {
                        $(`${data.action}`).modal('show')
                    }
                } else if(data.action_type == "video_popup") {
                    this.iframeSrc = data.video
                    $("#modalVideo").modal('show')
                }
            },
            defineRetrospective2024(){
                if(this.firstRetrospectiveAccess){
                    this.showConfetti()
                    this.firstRetrospectiveAccess = false
                    setTimeout(() => {
                        $(`#retrospective-2024`).modal('show')
                    }, 1500)
                } else {
                    $(`#retrospective-2024`).modal('show')
                }
            },
            showConfetti(){
                this.$confetti.start()
                setTimeout(() => {
                    this.$confetti.stop()
                }, 4000)
            },
            _isEmpty(val) {
                return isEmpty(val)
            }
        }
    }
</script>

<style lang="scss" scoped>
    .disable-click {
        cursor: default !important;
    }
    .modal {
        text-align: center;
        &::before {
            display: inline-block;
            vertical-align: middle;
            content: " ";
            height: 100%;
        }
        .modal-dialog {
            display: inline-block;
            text-align: left;
            vertical-align: middle;
            .modal-content{
                border-radius: 8px;
                .modal-body{
                    display: flex;
                    justify-content: center;
                    align-content: center;
                    padding: 1rem;
                    iframe{
                        border: none;
                        border-radius: 3px;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// resources/office/js/components/office-v6/dashboard/banners/BannerTop.vue